import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bs-modern-layout" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sidebar = _resolveComponent("sidebar")!
  const _component_bs_invoice_search = _resolveComponent("bs-invoice-search")!
  const _component_bs_account = _resolveComponent("bs-account")!
  const _component_bs_header = _resolveComponent("bs-header")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_sidebar, {
      "is-opened": _ctx.store.is_sidebar_opened,
      onToggle: _ctx.store.toggleSidebar
    }, null, 8, ["is-opened", "onToggle"]),
    _createElementVNode("div", {
      class: _normalizeClass(["bs-modern-layout__container", { 'container--opened': _ctx.store.is_sidebar_opened }])
    }, [
      _createVNode(_component_bs_header, null, {
        field: _withCtx(() => [
          _createVNode(_component_bs_invoice_search)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_bs_account, {
            username: _ctx.username,
            role: _ctx.role,
            onLogout: _ctx.onLogout
          }, null, 8, ["username", "role", "onLogout"])
        ]),
        _: 1
      }),
      _createVNode(_component_router_view)
    ], 2)
  ]))
}